import React, { useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import classnames from 'classnames';
import Events from '../../api/Events';

import sIcon1 from '../../images/icons/icon-1.png'
import sIcon2 from '../../images/icons/icon-2.png'
import sIcon3 from '../../images/icons/icon-3.png'
import sIcon4 from '../../images/icons/icon-4.png'
import sIcon5 from '../../images/background/pattern-10.png'

const EventsSection = (props) => {

    const [activeTab, setActiveTab] = useState('future');

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const renderEventButton = (event) => {
        if (event.status === 'active') {
            return (
                <a
                    href={event.inviteLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="event-invite-btn event-btn-active"
                >
                    Request Your Invite
                </a>
            );
        } else if (event.status === 'comingSoon') {
            return (
                <button className="event-invite-btn event-btn-disabled" disabled>
                    Coming Soon
                </button>
            );
        } else if (event.status === 'finished') {
            return (
                <button className="event-invite-btn event-btn-disabled" disabled>
                    Event Finished
                </button>
            );
        }
    };


    return (
        <section className="leadership-one" id='events'>
            <div className="leadership-one_icon" style={{ backgroundImage: `url(${sIcon1})` }}></div>
            <div className="leadership-one_icon-two" style={{ backgroundImage: `url(${sIcon2})` }}></div>
            <div className="leadership-one_icon-three" style={{ backgroundImage: `url(${sIcon3})` }}></div>
            <div className="leadership-one_icon-four" style={{ backgroundImage: `url(${sIcon4})` }}></div>
            <div className="leadership-one_icon-five" style={{ backgroundImage: `url(${sIcon5})` }}></div>
            <div className="auto-container">
                <div className="sec-title title-anim centered">
                    <div className="sec-title_title">Our Events</div>
                    <h2 className="sec-title_heading">Know What is Happening at <br /> The Lush Minds</h2>
                </div>
                <div className="leadership-info-tabs">
                    <div className="leadership-tabs tabs-box" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <ul className="">
                            <Nav tabs className="tab-btns tab-buttons clearfix">
                                <NavItem className='tab-btn'>
                                    <NavLink
                                        className={classnames({ active: activeTab === 'future' })}
                                        onClick={() => { toggle('future'); }}
                                    >
                                        Upcoming
                                        <span>What will Happen</span>
                                    </NavLink>
                                </NavItem>
                                <NavItem className='tab-btn'>
                                    <NavLink
                                        className={classnames({ active: activeTab === 'past' })}
                                        onClick={() => { toggle('past'); }}
                                    >
                                        Recent
                                        <span>What Happened</span>
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </ul>
                        <div className="tabs-content">
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId='future' className={classnames('tab', { 'active-tab': activeTab === 'future' })}>
                                    {Events.filter(event => ['1','5'].includes(event.Id))
                                        .sort((a, b) => ['5', '1'].indexOf(a.Id) - ['5', '1'].indexOf(b.Id))
                                        .map((event, idx) => (
                                            <div className="content" key={idx}>
                                                <div className="leadership-one_block">
                                                    <div className="leadership-one_block-inner">
                                                        <div className="leadership-one_block-content">
                                                            <div className="leadership-one_block-image">
                                                                <img src={event.eImg} alt="" />
                                                                <div className="leadership-one_block-icon"><i className={`fi ${event.Icon}`}></i></div>
                                                            </div>
                                                            <div className="leadership-one_block-time">{event.time}</div>
                                                            <div className="leadership-one_block-name">{event.speaker}</div>
                                                            <h3 className="leadership-one_block-title">{event.eTitle}</h3>
                                                            <div className="leadership-one_block-text">{event.des}</div>
                                                            <div className="leadership-one_block-button">
                                                                {renderEventButton(event)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                </TabPane>
                                <TabPane tabId='past' className={classnames('tab', { 'active-tab': activeTab === 'past' })}>
                                    {Events.filter(event => ['2','3','4'].includes(event.Id)).map((event, idx) => (
                                        <div className="content" key={idx}>
                                            <div className="leadership-one_block">
                                                <div className="leadership-one_block-inner">
                                                    <div className="leadership-one_block-content">
                                                        <div className="leadership-one_block-image">
                                                            <img src={event.eImg} alt="" />
                                                            <div className="leadership-one_block-icon"><i className={`fi ${event.Icon}`}></i></div>
                                                        </div>
                                                        <div className="leadership-one_block-time">{event.time}</div>
                                                        <div className="leadership-one_block-name">{event.speaker}</div>
                                                        <h3 className="leadership-one_block-title">{event.eTitle}</h3>
                                                        <div className="leadership-one_block-text">{event.des}</div>
                                                        <div className="leadership-one_block-button">
                                                            {renderEventButton(event)}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </TabPane>
                            </TabContent>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default EventsSection;